import { createAPI } from '@common'

export default {
  // 批量生成邀请码
  postUcInvitecodeInit: config => createAPI('customEncryptApiName-1/0w20vd0jowjufdpef0joju', 'post', config),
  // 下载二维码-批量
  getUcInvitecodeDownloadbatch: config => createAPI('customEncryptApiName-1/0w20vd0jowjufdpef0epxompbecbudi', 'get', config),
  // 下载二维码
  getUcInvitecodeDownload: config => createAPI('customEncryptApiName-1/0w20vd0jowjufdpef0epxompbe', 'get', config),
  // 删除
  postUcInvitecodeDelete: config => createAPI('customEncryptApiName-1/0w20vd0jowjufdpef0efmfuf', 'post', config),
  // 判断是否存在二维码（邀请码单位代号）
  gettUcInvitecodeExist: config => createAPI('customEncryptApiName-1/0w20vd0jowjufdpef0fyjtu', 'get', config)
}
